import React, { Fragment } from 'react';
import moment from 'moment';
import {
  Box,
  Paper,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
} from '@mui/material';

import NoDataFound from '../../../components/UI/NoDataFound';
import CONSTANTS from '../../../utils/constants/common';
import ICButton from '../../../components/UI/IconButton';
import { useAuth } from '../../../context/AuthContext';

const NotesList = (props) => {
  const { user } = useAuth();

  const currentUserId = user?._id;
  const isAdmin = [
    CONSTANTS.USER_TYPE.MASTER_ADMIN,
    CONSTANTS.USER_TYPE.ADMIN,
    CONSTANTS.USER_TYPE.SUPER_ADMIN,
  ].includes(user?.userType);

  return (
    <Fragment>
      <Paper sx={{ width: '100%', mt: 4 }} className="protocol-lists">
        <TableContainer className="primary-table-color scroll-table-ipad-max-height">
          <Table stickyHeader aria-label="sticky table">
            <TableBody>
              {props.notesList &&
                props.notesList.map((row) => {
                  const isAddedByCurrentUser = row.addedBy._id === currentUserId;

                  return (
                    <TableRow hover key={row._id}>
                      <TableCell className="primary-color cursor-pointer">
                        {!row.note ? (
                          <>
                            <Typography>
                              {
                                <p>
                                  <b>Presenting Complaint: </b>
                                  {row.complaint}
                                </p>
                              }
                            </Typography>
                            <Typography>
                              {
                                <p>
                                  <b>Impression: </b>
                                  {row.impression}
                                </p>
                              }
                            </Typography>
                            <Typography>
                              {
                                <p>
                                  <b>Plan: </b>
                                  {row.plan}
                                </p>
                              }
                            </Typography>
                          </>
                        ) : (
                          <Typography>{row.note}</Typography>
                        )}
                        <Box display="flex" alignItems="flex-end" justifyContent="space-between">
                          <Typography sx={{ fontSize: 12 }}>
                            {row.addedBy.displayFirstName +
                              ' ' +
                              row.addedBy.lastName +
                              ' | ' +
                              moment(row.createdDate).format('Do MMMM yyyy')}
                          </Typography>
                          {(isAdmin || isAddedByCurrentUser) && (
                            <ICButton
                              title=""
                              type="button"
                              icon="fas fa-trash-alt"
                              className="only-icon danger"
                              clickEvent={() => props.deleteNote(row._id)}
                            />
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {(!props.notesList || !props.notesList.length) && <NoDataFound />}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Fragment>
  );
};

export default NotesList;
